export default {
  Title: 'Why #{caregiverFirstName} fits #{clientFirstName}\'s care plan',
  YourLovedOne: 'your loved one',
};
